import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import Theme from "../themes";
import { useHistory } from "react-router-dom";
import ApiService from "../helpers/ApiService";
import { withRedux } from "../helpers/redux";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import "../themes/main.css";
import NavBar from "../components/common/navbar";
import Footer from "../components/common/Footer";
import { Grid, CircularProgress, Box, Dialog } from "@material-ui/core";
import BtLogo from "../components/common/BtLogo";
import BtAlert from "../components/common/BtAlert";
import Analytics from "../helpers/AnalyticsService";
import HelmetComponent from "../components/common/HelmetComponent";

const useStore = () => {
  return useSelector(
    (state) => ({
      user: state.user || {},
    }),
    shallowEqual
  );
};

const DefaultLayout = ({ children }) => {
  const [loading, setLoading] = React.useState(true);
  const dispatch = useDispatch();
  const { user } = useStore();
  let history = useHistory();

  // history.events.on('routeChangeStart', url => {
  //   setLoading(true)
  // })

  // history.events.on('routeChangeComplete', url => {
  //   setLoading(false)
  //   let page = url.substr(1).replace(/-/g, ' ')
  //   page = page.charAt(0).toUpperCase() + page.substr(1) + ' - Big Tester'
  //   document.title = page.split('/')[0]
  // })

  const authInitialize = async () => {
    if (!user.id) {
      const user = await ApiService.autoLogin();

      if (user) {
        dispatch({
          type: "SET_USER",
          user,
        });

        // inserindo js do on push site para área logada
        const s = document.createElement("script");
        s.src = "//cdn.pn.vg/sites/8a660387-85ad-48d0-adb9-ab9561b7d7ec.js";
        s.async = true;
        document.body.prepend(s);

      } else {
        history.push("/");
      }
    }

    makeAnalytics();
  };

  const makeAnalytics = () => {
    const analytics = new Analytics(user.id);
    analytics.registerPage(history.route);
  };

  React.useEffect(() => {
    setTimeout(() => {
      if (loading) setLoading(false);
    }, 2000);
    authInitialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const Page = () => (
    <ThemeProvider theme={Theme}>
      <HelmetComponent />
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        // maxWidth="xl"
      >
        <BtAlert />
        <NavBar />
        {children}
        <Footer />
      </Grid>
    </ThemeProvider>
  );

  const LoadingScreen = () => (
    <Dialog
      open={loading}
      fullScreen
      style={{ backgroundColor: "transparent" }}
    >
      <Grid
        container
        style={{ height: "100%" }}
        alignItems="center"
        justify="center"
      >
        <Box
          style={{
            position: "absolute",
            height: 180,
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <BtLogo type="colored" style={{ margin: "auto" }} />
        </Box>
        <CircularProgress className="primary--text" size={180} thickness={4} />
      </Grid>
    </Dialog>
  );

  return loading ? <LoadingScreen /> : <Page />;
};

export default withRedux(DefaultLayout);
